'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _findIndex2 = require('lodash/findIndex');

var _findIndex3 = _interopRequireDefault(_findIndex2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _desc, _value, _class2;

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mobx = require('mobx');

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

var _FormDataUtils = require('../utils/FormDataUtils');

var _FormDataUtils2 = _interopRequireDefault(_FormDataUtils);

var _AppConstants = require('../constants/AppConstants');

var _AppConstants2 = _interopRequireDefault(_AppConstants);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var LIEN_MODELS = _AppConstants2.default.LIEN_MODELS,
    LIEN_MODELS_BY_MODEL_NAME = _AppConstants2.default.LIEN_MODELS_BY_MODEL_NAME,
    MODEL_TYPES = _AppConstants2.default.MODEL_TYPES;

var LienStore = (0, _classAutobindDecorator2.default)(_class = (_class2 = function () {
  function LienStore(flatStore, caseStore, transport) {
    _classCallCheck(this, LienStore);

    this.flatStore = flatStore;
    this.caseStore = caseStore;
    this.transport = transport;
  }

  _createClass(LienStore, [{
    key: 'retrieve',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id, type) {
        var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
            _ref2$includeDocument = _ref2.includeDocuments,
            includeDocuments = _ref2$includeDocument === undefined ? false : _ref2$includeDocument,
            _ref2$legacy = _ref2.legacy,
            legacy = _ref2$legacy === undefined ? false : _ref2$legacy;

        var endpoint, lienData, lien;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endpoint = legacy ? '/legacy-liens/:id/' : '/' + type + '-liens/:id/';
                _context.next = 3;
                return this.transport.get(endpoint, { urlParams: { id: id } });

              case 3:
                lienData = _context.sent;
                lien = this.flatStore.lien.store(lienData);

                if (!includeDocuments) {
                  _context.next = 8;
                  break;
                }

                _context.next = 8;
                return this.listLienDocuments(id);

              case 8:
                return _context.abrupt('return', lien);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function retrieve(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return retrieve;
    }()
  }, {
    key: 'fetchPresets',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var presets;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.transport.get('/funder-preset-contract-templates/');

              case 2:
                presets = _context2.sent;
                return _context2.abrupt('return', presets);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchPresets() {
        return _ref3.apply(this, arguments);
      }

      return fetchPresets;
    }()
  }, {
    key: 'upsertLegalFundingLien',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref5) {
        var caseId = _ref5.caseId,
            lienId = _ref5.lienId,
            data = _ref5.data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                Object.assign(data, {
                  case: caseId,
                  fees: data.fees || [],
                  id: lienId || _uuid2.default.v4()
                });

                _context3.next = 3;
                return this.upsert(data, LIEN_MODELS.LEGAL_FUNDING.key);

              case 3:
                return _context3.abrupt('return', _context3.sent);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function upsertLegalFundingLien(_x4) {
        return _ref4.apply(this, arguments);
      }

      return upsertLegalFundingLien;
    }()
  }, {
    key: 'upsert',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(data, typeKey) {
        var endpoint, id;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                endpoint = LIEN_MODELS[typeKey].endpoint, id = data.id;

                // Supports upsert via post

                if (!(typeKey === LIEN_MODELS.LEGAL_FUNDING.key)) {
                  _context4.next = 6;
                  break;
                }

                _context4.next = 4;
                return this.transport.post('/' + endpoint + '/', { data: data });

              case 4:
                _context4.next = 14;
                break;

              case 6:
                if (id) {
                  _context4.next = 12;
                  break;
                }

                data.id = _uuid2.default.v4();
                _context4.next = 10;
                return this.transport.post('/' + endpoint + '/', { data: data });

              case 10:
                _context4.next = 14;
                break;

              case 12:
                _context4.next = 14;
                return this.transport.patch('/' + endpoint + '/:id/', { data: data, urlParams: { id: id } });

              case 14:
                _context4.next = 16;
                return Promise.all([this.list({ caseId: data.case }), this.caseStore.refresh(data.case)]);

              case 16:
                return _context4.abrupt('return', this.flatStore.lien.get(data.id));

              case 17:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function upsert(_x5, _x6) {
        return _ref6.apply(this, arguments);
      }

      return upsert;
    }()
  }, {
    key: 'createOrUpdateGenericLien',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(data) {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.upsert(data, LIEN_MODELS.GENERIC.key);

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function createOrUpdateGenericLien(_x7) {
        return _ref7.apply(this, arguments);
      }

      return createOrUpdateGenericLien;
    }()
  }, {
    key: 'delete',
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref9) {
        var caseId = _ref9.caseId,
            lienId = _ref9.lienId;

        var _flatStore$lien$get, amount_owed_to_coop, request;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _flatStore$lien$get = this.flatStore.lien.get(lienId), amount_owed_to_coop = _flatStore$lien$get.amount_owed_to_coop;

                if (!(amount_owed_to_coop !== null)) {
                  _context6.next = 4;
                  break;
                }

                _utils.toast.error('Cannot delete a lien linked to a CoOp investment. Please contact Mighty Support for further assistance.');
                return _context6.abrupt('return');

              case 4:
                request = this.transport.delete('/liens/:id/', { urlParams: { id: lienId } });
                _context6.next = 7;
                return this.caseStore.caseActivities.loadNew(MODEL_TYPES.lienDeleted.key, request);

              case 7:
                _context6.next = 9;
                return this.list({ caseId: caseId });

              case 9:
                _context6.next = 11;
                return this.caseStore.refresh(caseId);

              case 11:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function _delete(_x8) {
        return _ref8.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: 'rawUpdate',
    value: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(lien, data) {
        var endpoint;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                endpoint = LIEN_MODELS_BY_MODEL_NAME[lien.type].endpoint;
                return _context7.abrupt('return', this.transport.patch('/' + endpoint + '/:lienId/', { data: data, urlParams: { lienId: lien.id } }));

              case 2:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function rawUpdate(_x9, _x10) {
        return _ref10.apply(this, arguments);
      }

      return rawUpdate;
    }()
  }, {
    key: 'update',
    value: function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(lien, data) {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.t0 = this.flatStore.lien;
                _context8.next = 3;
                return this.rawUpdate(lien, data);

              case 3:
                _context8.t1 = _context8.sent;
                return _context8.abrupt('return', _context8.t0.store.call(_context8.t0, _context8.t1));

              case 5:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function update(_x11, _x12) {
        return _ref11.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: 'bulkUpdate',
    value: function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(liens, data) {
        var _this = this;

        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt('return', Promise.all(liens.map(function (lien) {
                  return _this.rawUpdate(lien, data);
                })));

              case 1:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function bulkUpdate(_x13, _x14) {
        return _ref12.apply(this, arguments);
      }

      return bulkUpdate;
    }()
  }, {
    key: 'updateLienDocument',
    value: function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(id, data) {
        var form;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                form = _FormDataUtils2.default.toForm(data);
                _context10.next = 3;
                return this.transport.patch('/lien-documents/:id/', { data: form, urlParams: { id: id } });

              case 3:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function updateLienDocument(_x15, _x16) {
        return _ref13.apply(this, arguments);
      }

      return updateLienDocument;
    }()
  }, {
    key: 'list',
    value: function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(_ref15) {
        var _this2 = this;

        var caseId = _ref15.caseId;

        var _case, params, liens;

        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _case = this.flatStore.case.get(caseId), params = { case: caseId };

                if (!_case.loadingLiens) {
                  _context11.next = 3;
                  break;
                }

                return _context11.abrupt('return');

              case 3:

                _case.loadingLiens = true;
                _context11.next = 6;
                return this.transport.getAll('/liens/', { params: params });

              case 6:
                liens = _context11.sent;

                liens.forEach(function (lien) {
                  return _this2.flatStore.lien.store(lien);
                });
                _case.liens = liens.map(function (lien) {
                  return lien.id;
                });
                _case.loadingLiens = false;

              case 10:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function list(_x17) {
        return _ref14.apply(this, arguments);
      }

      return list;
    }()
  }, {
    key: 'createLienReturn',
    value: function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(_ref17) {
        var caseId = _ref17.caseId,
            data = _ref17.data;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.transport.post('/returns/', { data: data });

              case 2:
                _context12.next = 4;
                return Promise.all([this.caseStore.caseActivities.loadNew(MODEL_TYPES.lienReturnAction.key), this.caseStore.refresh(caseId), this.list({ caseId: caseId })]);

              case 4:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function createLienReturn(_x18) {
        return _ref16.apply(this, arguments);
      }

      return createLienReturn;
    }()
  }, {
    key: 'deleteLienReturn',
    value: function () {
      var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(returnId, lienId, caseId) {
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.transport.delete('/returns/:returnId/', { urlParams: { returnId: returnId } });

              case 2:
                _context13.next = 4;
                return Promise.all([this.caseStore.caseActivities.loadNew(MODEL_TYPES.lienReturnAction.key), this.caseStore.refresh(caseId), this.list({ caseId: caseId })]);

              case 4:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function deleteLienReturn(_x19, _x20, _x21) {
        return _ref18.apply(this, arguments);
      }

      return deleteLienReturn;
    }()
  }, {
    key: 'createLienDocument',
    value: function () {
      var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(_ref20) {
        var lienId = _ref20.lienId,
            data = _ref20.data;
        var form, lienDocument, lien;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                form = new window.FormData();


                form.append('lien', lienId);
                form.append('file', data.file);
                form.append('name', data.name);

                _context14.next = 6;
                return this.transport.post('/lien-documents/', { data: form });

              case 6:
                lienDocument = _context14.sent;
                lien = this.flatStore.lien.get(lienId);


                lien.documents.push(lienDocument);

              case 9:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function createLienDocument(_x22) {
        return _ref19.apply(this, arguments);
      }

      return createLienDocument;
    }()
  }, {
    key: 'deleteLienDocument',
    value: function () {
      var _ref21 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(lienId, caseId, id) {
        var request;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                request = this.transport.delete('/lien-documents/:id/', { urlParams: { id: id } });
                _context15.next = 3;
                return this.caseStore.caseActivities.loadNew(MODEL_TYPES.deletedLienDocument.key, request);

              case 3:
                this.caseStore.fetchTabCounts(caseId);

              case 4:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function deleteLienDocument(_x23, _x24, _x25) {
        return _ref21.apply(this, arguments);
      }

      return deleteLienDocument;
    }()
  }, {
    key: 'listLienDocuments',
    value: function () {
      var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(lienId) {
        var params, documents, lien;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                params = { lien: lienId, page_size: 'off' };
                _context16.next = 3;
                return this.transport.get('/lien-documents/', { params: params });

              case 3:
                documents = _context16.sent;
                lien = this.flatStore.lien.get(lienId);


                lien.extend({ documents: documents });

              case 6:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function listLienDocuments(_x26) {
        return _ref22.apply(this, arguments);
      }

      return listLienDocuments;
    }()
  }, {
    key: 'listCaseLienDocuments',
    value: function () {
      var _ref23 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(caseId) {
        var params;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                params = { case: caseId, page_size: 'off' };
                _context17.next = 3;
                return this.transport.get('/lien-documents/', { params: params });

              case 3:
                return _context17.abrupt('return', _context17.sent);

              case 4:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function listCaseLienDocuments(_x27) {
        return _ref23.apply(this, arguments);
      }

      return listCaseLienDocuments;
    }()
  }, {
    key: 'downloadContract',
    value: function downloadContract(lien) {
      window.location = this.transport.addAuthenticationToUrl(lien.contract_download_url);
    }
  }, {
    key: 'updateFunding',
    value: function updateFunding(funding) {
      var lien = this.flatStore.lien.get(funding.lien),
          fundingIndex = (0, _findIndex3.default)(lien.capital_fundings, { id: funding.id });

      if (fundingIndex < 0) {
        lien.capital_fundings.push(funding);
      } else {
        (0, _mobx.extendObservable)(lien.capital_fundings[fundingIndex], funding);
      }
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return LienStore;
}(), (_applyDecoratedDescriptor(_class2.prototype, 'retrieve', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'retrieve'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'fetchPresets', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'fetchPresets'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'upsertLegalFundingLien', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'upsertLegalFundingLien'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'upsert', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'upsert'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'createOrUpdateGenericLien', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'createOrUpdateGenericLien'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'delete', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'delete'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'update', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'update'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateLienDocument', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'updateLienDocument'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'list', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'list'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'createLienReturn', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'createLienReturn'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'deleteLienReturn', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'deleteLienReturn'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'createLienDocument', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'createLienDocument'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'deleteLienDocument', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'deleteLienDocument'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'listLienDocuments', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'listLienDocuments'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'listCaseLienDocuments', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'listCaseLienDocuments'), _class2.prototype)), _class2)) || _class;

var _default = LienStore;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(LIEN_MODELS, 'LIEN_MODELS', '/app/src/stores/LienStore.js');
  reactHotLoader.register(LIEN_MODELS_BY_MODEL_NAME, 'LIEN_MODELS_BY_MODEL_NAME', '/app/src/stores/LienStore.js');
  reactHotLoader.register(MODEL_TYPES, 'MODEL_TYPES', '/app/src/stores/LienStore.js');
  reactHotLoader.register(LienStore, 'LienStore', '/app/src/stores/LienStore.js');
  reactHotLoader.register(_default, 'default', '/app/src/stores/LienStore.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9zdG9yZXMvTGllblN0b3JlLmpzIl0sIm5hbWVzIjpbIkxJRU5fTU9ERUxTIiwiQXBwQ29uc3RhbnRzIiwiTElFTl9NT0RFTFNfQllfTU9ERUxfTkFNRSIsIk1PREVMX1RZUEVTIiwiTGllblN0b3JlIiwiYXV0b0JpbmRNZXRob2RzIiwiZmxhdFN0b3JlIiwiY2FzZVN0b3JlIiwidHJhbnNwb3J0IiwiaWQiLCJ0eXBlIiwiaW5jbHVkZURvY3VtZW50cyIsImxlZ2FjeSIsImVuZHBvaW50IiwiZ2V0IiwidXJsUGFyYW1zIiwibGllbkRhdGEiLCJsaWVuIiwic3RvcmUiLCJsaXN0TGllbkRvY3VtZW50cyIsInByZXNldHMiLCJjYXNlSWQiLCJsaWVuSWQiLCJkYXRhIiwiT2JqZWN0IiwiYXNzaWduIiwiY2FzZSIsImZlZXMiLCJ1dWlkIiwidjQiLCJ1cHNlcnQiLCJMRUdBTF9GVU5ESU5HIiwia2V5IiwidHlwZUtleSIsInBvc3QiLCJwYXRjaCIsIlByb21pc2UiLCJhbGwiLCJsaXN0IiwicmVmcmVzaCIsIkdFTkVSSUMiLCJhbW91bnRfb3dlZF90b19jb29wIiwidG9hc3QiLCJlcnJvciIsInJlcXVlc3QiLCJkZWxldGUiLCJjYXNlQWN0aXZpdGllcyIsImxvYWROZXciLCJsaWVuRGVsZXRlZCIsInJhd1VwZGF0ZSIsImxpZW5zIiwibWFwIiwiZm9ybSIsIkZvcm1EYXRhVXRpbHMiLCJ0b0Zvcm0iLCJfY2FzZSIsInBhcmFtcyIsImxvYWRpbmdMaWVucyIsImdldEFsbCIsImZvckVhY2giLCJsaWVuUmV0dXJuQWN0aW9uIiwicmV0dXJuSWQiLCJ3aW5kb3ciLCJGb3JtRGF0YSIsImFwcGVuZCIsImZpbGUiLCJuYW1lIiwibGllbkRvY3VtZW50IiwiZG9jdW1lbnRzIiwicHVzaCIsImRlbGV0ZWRMaWVuRG9jdW1lbnQiLCJmZXRjaFRhYkNvdW50cyIsInBhZ2Vfc2l6ZSIsImV4dGVuZCIsImxvY2F0aW9uIiwiYWRkQXV0aGVudGljYXRpb25Ub1VybCIsImNvbnRyYWN0X2Rvd25sb2FkX3VybCIsImZ1bmRpbmciLCJmdW5kaW5nSW5kZXgiLCJjYXBpdGFsX2Z1bmRpbmdzIiwiYWN0aW9uIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7OztBQUNBOzs7O0FBQ0E7O0FBQ0E7Ozs7QUFFQTs7OztBQUVBOzs7O0FBQ0E7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUFHRUEsVyxHQUdFQyxzQixDQUhGRCxXO0lBQ0FFLHlCLEdBRUVELHNCLENBRkZDLHlCO0lBQ0FDLFcsR0FDRUYsc0IsQ0FERkUsVzs7SUFLSUMsUyxPQURMQyxnQztBQUVDLHFCQUFhQyxTQUFiLEVBQXdCQyxTQUF4QixFQUFtQ0MsU0FBbkMsRUFBOEM7QUFBQTs7QUFDNUMsU0FBS0YsU0FBTCxHQUFpQkEsU0FBakI7QUFDQSxTQUFLQyxTQUFMLEdBQWlCQSxTQUFqQjtBQUNBLFNBQUtDLFNBQUwsR0FBaUJBLFNBQWpCO0FBQ0Q7Ozs7OzBGQUdlQyxFLEVBQUlDLEk7d0ZBQXFELEU7MENBQTdDQyxnQjtZQUFBQSxnQix5Q0FBbUIsSztpQ0FBT0MsTTtZQUFBQSxNLGdDQUFTLEs7Ozs7Ozs7QUFDdkRDLHdCLEdBQVdELFNBQVMsb0JBQVQsU0FBb0NGLElBQXBDLGdCOzt1QkFDSSxLQUFLRixTQUFMLENBQWVNLEdBQWYsQ0FBbUJELFFBQW5CLEVBQTZCLEVBQUVFLFdBQVcsRUFBRU4sTUFBRixFQUFiLEVBQTdCLEM7OztBQUFqQk8sd0I7QUFDQUMsb0IsR0FBTyxLQUFLWCxTQUFMLENBQWVXLElBQWYsQ0FBb0JDLEtBQXBCLENBQTBCRixRQUExQixDOztxQkFHUEwsZ0I7Ozs7Ozt1QkFDSSxLQUFLUSxpQkFBTCxDQUF1QlYsRUFBdkIsQzs7O2lEQUdEUSxJOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozt1QkFLZSxLQUFLVCxTQUFMLENBQWVNLEdBQWYsQ0FBbUIsb0NBQW5CLEM7OztBQUFoQk0sdUI7a0RBQ0NBLE87Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O1lBSXVCQyxNLFNBQUFBLE07WUFBUUMsTSxTQUFBQSxNO1lBQVFDLEksU0FBQUEsSTs7Ozs7QUFDOUNDLHVCQUFPQyxNQUFQLENBQWNGLElBQWQsRUFBb0I7QUFDbEJHLHdCQUFNTCxNQURZO0FBRWxCTSx3QkFBTUosS0FBS0ksSUFBTCxJQUFhLEVBRkQ7QUFHbEJsQixzQkFBSWEsVUFBVU0sZUFBS0MsRUFBTDtBQUhJLGlCQUFwQjs7O3VCQU1jLEtBQUtDLE1BQUwsQ0FBWVAsSUFBWixFQUFrQnZCLFlBQVkrQixhQUFaLENBQTBCQyxHQUE1QyxDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OzRGQUlGVCxJLEVBQU1VLE87Ozs7OztBQUNacEIsd0IsR0FBV2IsWUFBWWlDLE9BQVosRUFBcUJwQixRLEVBQ2hDSixFLEdBQU9jLEksQ0FBUGQsRTs7QUFFTjs7c0JBQ0l3QixZQUFZakMsWUFBWStCLGFBQVosQ0FBMEJDLEc7Ozs7Ozt1QkFDbEMsS0FBS3hCLFNBQUwsQ0FBZTBCLElBQWYsT0FBd0JyQixRQUF4QixRQUFxQyxFQUFDVSxVQUFELEVBQXJDLEM7Ozs7Ozs7b0JBSUVkLEU7Ozs7O0FBQ1JjLHFCQUFLZCxFQUFMLEdBQVVtQixlQUFLQyxFQUFMLEVBQVY7O3VCQUNNLEtBQUtyQixTQUFMLENBQWUwQixJQUFmLE9BQXdCckIsUUFBeEIsUUFBcUMsRUFBQ1UsVUFBRCxFQUFyQyxDOzs7Ozs7Ozt1QkFLQSxLQUFLZixTQUFMLENBQWUyQixLQUFmLE9BQXlCdEIsUUFBekIsWUFBMEMsRUFBQ1UsVUFBRCxFQUFPUixXQUFXLEVBQUVOLE1BQUYsRUFBbEIsRUFBMUMsQzs7Ozt1QkFHRjJCLFFBQVFDLEdBQVIsQ0FBWSxDQUNoQixLQUFLQyxJQUFMLENBQVUsRUFBRWpCLFFBQVFFLEtBQUtHLElBQWYsRUFBVixDQURnQixFQUVoQixLQUFLbkIsU0FBTCxDQUFlZ0MsT0FBZixDQUF1QmhCLEtBQUtHLElBQTVCLENBRmdCLENBQVosQzs7O2tEQUtDLEtBQUtwQixTQUFMLENBQWVXLElBQWYsQ0FBb0JILEdBQXBCLENBQXdCUyxLQUFLZCxFQUE3QixDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7OzRGQUl3QmMsSTs7Ozs7O3VCQUN6QixLQUFLTyxNQUFMLENBQVlQLElBQVosRUFBa0J2QixZQUFZd0MsT0FBWixDQUFvQlIsR0FBdEMsQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7WUFJUVgsTSxTQUFBQSxNO1lBQVFDLE0sU0FBQUEsTTs7Ozs7Ozs7c0NBQ1UsS0FBS2hCLFNBQUwsQ0FBZVcsSUFBZixDQUFvQkgsR0FBcEIsQ0FBd0JRLE1BQXhCLEMsRUFBeEJtQixtQix1QkFBQUEsbUI7O3NCQUVKQSx3QkFBd0IsSTs7Ozs7QUFDMUJDLDZCQUFNQyxLQUFOLENBQ0UseUdBREY7Ozs7QUFNSUMsdUIsR0FBVSxLQUFLcEMsU0FBTCxDQUFlcUMsTUFBZixDQUFzQixhQUF0QixFQUFxQyxFQUFFOUIsV0FBVyxFQUFFTixJQUFJYSxNQUFOLEVBQWIsRUFBckMsQzs7dUJBRVYsS0FBS2YsU0FBTCxDQUFldUMsY0FBZixDQUE4QkMsT0FBOUIsQ0FBc0M1QyxZQUFZNkMsV0FBWixDQUF3QmhCLEdBQTlELEVBQW1FWSxPQUFuRSxDOzs7O3VCQUNBLEtBQUtOLElBQUwsQ0FBVSxFQUFFakIsY0FBRixFQUFWLEM7Ozs7dUJBQ0EsS0FBS2QsU0FBTCxDQUFlZ0MsT0FBZixDQUF1QmxCLE1BQXZCLEM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7NkZBR1NKLEksRUFBTU0sSTs7Ozs7O0FBQ2ZWLHdCLEdBQVdYLDBCQUEwQmUsS0FBS1AsSUFBL0IsRUFBcUNHLFE7a0RBQy9DLEtBQUtMLFNBQUwsQ0FBZTJCLEtBQWYsT0FBeUJ0QixRQUF6QixnQkFBOEMsRUFBRVUsVUFBRixFQUFRUixXQUFXLEVBQUVPLFFBQVFMLEtBQUtSLEVBQWYsRUFBbkIsRUFBOUMsQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs2RkFJS1EsSSxFQUFNTSxJOzs7OzsrQkFDWCxLQUFLakIsU0FBTCxDQUFlVyxJOzt1QkFBaUIsS0FBS2dDLFNBQUwsQ0FBZWhDLElBQWYsRUFBcUJNLElBQXJCLEM7Ozs7K0RBQVpMLEs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7NkZBR1hnQyxLLEVBQU8zQixJOzs7Ozs7O2tEQUNoQmEsUUFBUUMsR0FBUixDQUFZYSxNQUFNQyxHQUFOLENBQVUsVUFBQ2xDLElBQUQ7QUFBQSx5QkFBVSxNQUFLZ0MsU0FBTCxDQUFlaEMsSUFBZixFQUFxQk0sSUFBckIsQ0FBVjtBQUFBLGlCQUFWLENBQVosQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs4RkFJaUJkLEUsRUFBSWMsSTs7Ozs7O0FBQ3RCNkIsb0IsR0FBT0Msd0JBQWNDLE1BQWQsQ0FBcUIvQixJQUFyQixDOzt1QkFDUCxLQUFLZixTQUFMLENBQWUyQixLQUFmLENBQXFCLHNCQUFyQixFQUE2QyxFQUFFWixNQUFNNkIsSUFBUixFQUFjckMsV0FBVyxFQUFFTixNQUFGLEVBQXpCLEVBQTdDLEM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7WUFJTVksTSxVQUFBQSxNOzs7Ozs7OztBQUNOa0MscUIsR0FBUSxLQUFLakQsU0FBTCxDQUFlb0IsSUFBZixDQUFvQlosR0FBcEIsQ0FBd0JPLE1BQXhCLEMsRUFDVm1DLE0sR0FBUyxFQUFFOUIsTUFBTUwsTUFBUixFOztxQkFFVGtDLE1BQU1FLFk7Ozs7Ozs7OztBQUVWRixzQkFBTUUsWUFBTixHQUFxQixJQUFyQjs7dUJBQ29CLEtBQUtqRCxTQUFMLENBQWVrRCxNQUFmLENBQXNCLFNBQXRCLEVBQWlDLEVBQUVGLGNBQUYsRUFBakMsQzs7O0FBQWROLHFCOztBQUNOQSxzQkFBTVMsT0FBTixDQUFjO0FBQUEseUJBQVEsT0FBS3JELFNBQUwsQ0FBZVcsSUFBZixDQUFvQkMsS0FBcEIsQ0FBMEJELElBQTFCLENBQVI7QUFBQSxpQkFBZDtBQUNBc0Msc0JBQU1MLEtBQU4sR0FBY0EsTUFBTUMsR0FBTixDQUFVO0FBQUEseUJBQVFsQyxLQUFLUixFQUFiO0FBQUEsaUJBQVYsQ0FBZDtBQUNBOEMsc0JBQU1FLFlBQU4sR0FBcUIsS0FBckI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O1lBSXdCcEMsTSxVQUFBQSxNO1lBQVFFLEksVUFBQUEsSTs7Ozs7O3VCQUMxQixLQUFLZixTQUFMLENBQWUwQixJQUFmLENBQW9CLFdBQXBCLEVBQWlDLEVBQUVYLFVBQUYsRUFBakMsQzs7Ozt1QkFFQWEsUUFBUUMsR0FBUixDQUFZLENBQ2hCLEtBQUs5QixTQUFMLENBQWV1QyxjQUFmLENBQThCQyxPQUE5QixDQUFzQzVDLFlBQVl5RCxnQkFBWixDQUE2QjVCLEdBQW5FLENBRGdCLEVBRWhCLEtBQUt6QixTQUFMLENBQWVnQyxPQUFmLENBQXVCbEIsTUFBdkIsQ0FGZ0IsRUFHaEIsS0FBS2lCLElBQUwsQ0FBVSxFQUFFakIsY0FBRixFQUFWLENBSGdCLENBQVosQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs4RkFRZ0J3QyxRLEVBQVV2QyxNLEVBQVFELE07Ozs7Ozt1QkFDbEMsS0FBS2IsU0FBTCxDQUFlcUMsTUFBZixDQUFzQixxQkFBdEIsRUFBNkMsRUFBQzlCLFdBQVcsRUFBRThDLGtCQUFGLEVBQVosRUFBN0MsQzs7Ozt1QkFFQXpCLFFBQVFDLEdBQVIsQ0FBWSxDQUNoQixLQUFLOUIsU0FBTCxDQUFldUMsY0FBZixDQUE4QkMsT0FBOUIsQ0FBc0M1QyxZQUFZeUQsZ0JBQVosQ0FBNkI1QixHQUFuRSxDQURnQixFQUVoQixLQUFLekIsU0FBTCxDQUFlZ0MsT0FBZixDQUF1QmxCLE1BQXZCLENBRmdCLEVBR2hCLEtBQUtpQixJQUFMLENBQVUsRUFBRWpCLGNBQUYsRUFBVixDQUhnQixDQUFaLEM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O1lBUW9CQyxNLFVBQUFBLE07WUFBUUMsSSxVQUFBQSxJOzs7Ozs7QUFDNUI2QixvQixHQUFPLElBQUlVLE9BQU9DLFFBQVgsRTs7O0FBRWJYLHFCQUFLWSxNQUFMLENBQVksTUFBWixFQUFvQjFDLE1BQXBCO0FBQ0E4QixxQkFBS1ksTUFBTCxDQUFZLE1BQVosRUFBb0J6QyxLQUFLMEMsSUFBekI7QUFDQWIscUJBQUtZLE1BQUwsQ0FBWSxNQUFaLEVBQW9CekMsS0FBSzJDLElBQXpCOzs7dUJBRTJCLEtBQUsxRCxTQUFMLENBQWUwQixJQUFmLENBQW9CLGtCQUFwQixFQUF3QyxFQUFFWCxNQUFNNkIsSUFBUixFQUF4QyxDOzs7QUFBckJlLDRCO0FBQ0ZsRCxvQixHQUFPLEtBQUtYLFNBQUwsQ0FBZVcsSUFBZixDQUFvQkgsR0FBcEIsQ0FBd0JRLE1BQXhCLEM7OztBQUVYTCxxQkFBS21ELFNBQUwsQ0FBZUMsSUFBZixDQUFvQkYsWUFBcEI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OEZBSXdCN0MsTSxFQUFRRCxNLEVBQVFaLEU7Ozs7OztBQUNsQ21DLHVCLEdBQVUsS0FBS3BDLFNBQUwsQ0FBZXFDLE1BQWYsQ0FBc0Isc0JBQXRCLEVBQThDLEVBQUU5QixXQUFXLEVBQUVOLElBQUlBLEVBQU4sRUFBYixFQUE5QyxDOzt1QkFFVixLQUFLRixTQUFMLENBQWV1QyxjQUFmLENBQThCQyxPQUE5QixDQUFzQzVDLFlBQVltRSxtQkFBWixDQUFnQ3RDLEdBQXRFLEVBQTJFWSxPQUEzRSxDOzs7QUFDTixxQkFBS3JDLFNBQUwsQ0FBZWdFLGNBQWYsQ0FBOEJsRCxNQUE5Qjs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs4RkFJdUJDLE07Ozs7OztBQUNqQmtDLHNCLEdBQVMsRUFBRXZDLE1BQU1LLE1BQVIsRUFBZ0JrRCxXQUFXLEtBQTNCLEU7O3VCQUNPLEtBQUtoRSxTQUFMLENBQWVNLEdBQWYsQ0FBbUIsa0JBQW5CLEVBQXVDLEVBQUUwQyxjQUFGLEVBQXZDLEM7OztBQUFsQlkseUI7QUFDQW5ELG9CLEdBQU8sS0FBS1gsU0FBTCxDQUFlVyxJQUFmLENBQW9CSCxHQUFwQixDQUF3QlEsTUFBeEIsQzs7O0FBRVhMLHFCQUFLd0QsTUFBTCxDQUFZLEVBQUVMLG9CQUFGLEVBQVo7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OEZBSTJCL0MsTTs7Ozs7O0FBQ3JCbUMsc0IsR0FBUyxFQUFFOUIsTUFBTUwsTUFBUixFQUFnQm1ELFdBQVcsS0FBM0IsRTs7dUJBRUQsS0FBS2hFLFNBQUwsQ0FBZU0sR0FBZixDQUFtQixrQkFBbkIsRUFBdUMsRUFBRTBDLGNBQUYsRUFBdkMsQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O3FDQUdFdkMsSSxFQUFNO0FBQ3RCNkMsYUFBT1ksUUFBUCxHQUFrQixLQUFLbEUsU0FBTCxDQUFlbUUsc0JBQWYsQ0FBc0MxRCxLQUFLMkQscUJBQTNDLENBQWxCO0FBQ0Q7OztrQ0FFY0MsTyxFQUFTO0FBQ3RCLFVBQU01RCxPQUFPLEtBQUtYLFNBQUwsQ0FBZVcsSUFBZixDQUFvQkgsR0FBcEIsQ0FBd0IrRCxRQUFRNUQsSUFBaEMsQ0FBYjtBQUFBLFVBQ0k2RCxlQUFlLHlCQUFVN0QsS0FBSzhELGdCQUFmLEVBQWlDLEVBQUV0RSxJQUFJb0UsUUFBUXBFLEVBQWQsRUFBakMsQ0FEbkI7O0FBSUEsVUFBSXFFLGVBQWUsQ0FBbkIsRUFBc0I7QUFDcEI3RCxhQUFLOEQsZ0JBQUwsQ0FBc0JWLElBQXRCLENBQTJCUSxPQUEzQjtBQUNELE9BRkQsTUFHSztBQUNILG9DQUFpQjVELEtBQUs4RCxnQkFBTCxDQUFzQkQsWUFBdEIsQ0FBakIsRUFBc0RELE9BQXREO0FBQ0Q7QUFDRjs7Ozs7Ozs7Ozs7Z0VBaE1BRyxZLHFKQWNBQSxZLG1LQU1BQSxZLDZKQVdBQSxZLGdLQTZCQUEsWSxnS0FLQUEsWSw2SUF1QkFBLFkseUpBU0FBLFksdUpBTUFBLFkscUpBY0FBLFksaUtBV0FBLFksbUtBV0FBLFkscUtBY0FBLFksb0tBUUFBLFksdUtBU0FBLFk7O2VBeUJZNUUsUzs7Ozs7Ozs7Ozs7MEJBak5iSixXOzBCQUNBRSx5QjswQkFDQUMsVzswQkFLSUMsUyIsImZpbGUiOiJMaWVuU3RvcmUuanMiLCJzb3VyY2VSb290IjoiL2FwcCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGZpbmRJbmRleCB9IGZyb20gJ2xvZGFzaCc7XG5pbXBvcnQgYXV0b0JpbmRNZXRob2RzIGZyb20gJ2NsYXNzLWF1dG9iaW5kLWRlY29yYXRvcic7XG5pbXBvcnQgeyBhY3Rpb24sIGV4dGVuZE9ic2VydmFibGUgfSBmcm9tICdtb2J4JztcbmltcG9ydCB1dWlkIGZyb20gJ3V1aWQnO1xuXG5pbXBvcnQgRm9ybURhdGFVdGlscyBmcm9tICcuLi91dGlscy9Gb3JtRGF0YVV0aWxzJztcblxuaW1wb3J0IEFwcENvbnN0YW50cyBmcm9tICcuLi9jb25zdGFudHMvQXBwQ29uc3RhbnRzJztcbmltcG9ydCB7IHRvYXN0IH0gZnJvbSAnLi4vdXRpbHMnO1xuXG5jb25zdCB7XG4gIExJRU5fTU9ERUxTLFxuICBMSUVOX01PREVMU19CWV9NT0RFTF9OQU1FLFxuICBNT0RFTF9UWVBFUyxcbn0gPSBBcHBDb25zdGFudHM7XG5cblxuQGF1dG9CaW5kTWV0aG9kc1xuY2xhc3MgTGllblN0b3JlIHtcbiAgY29uc3RydWN0b3IgKGZsYXRTdG9yZSwgY2FzZVN0b3JlLCB0cmFuc3BvcnQpIHtcbiAgICB0aGlzLmZsYXRTdG9yZSA9IGZsYXRTdG9yZTtcbiAgICB0aGlzLmNhc2VTdG9yZSA9IGNhc2VTdG9yZTtcbiAgICB0aGlzLnRyYW5zcG9ydCA9IHRyYW5zcG9ydDtcbiAgfVxuXG4gIEBhY3Rpb25cbiAgYXN5bmMgcmV0cmlldmUgKGlkLCB0eXBlLCB7IGluY2x1ZGVEb2N1bWVudHMgPSBmYWxzZSwgbGVnYWN5ID0gZmFsc2UgfSA9IHt9KSB7XG4gICAgY29uc3QgZW5kcG9pbnQgPSBsZWdhY3kgPyAnL2xlZ2FjeS1saWVucy86aWQvJyA6IGAvJHt0eXBlfS1saWVucy86aWQvYFxuICAgICAgLCBsaWVuRGF0YSA9IGF3YWl0IHRoaXMudHJhbnNwb3J0LmdldChlbmRwb2ludCwgeyB1cmxQYXJhbXM6IHsgaWQgfX0pXG4gICAgICAsIGxpZW4gPSB0aGlzLmZsYXRTdG9yZS5saWVuLnN0b3JlKGxpZW5EYXRhKVxuICAgICAgO1xuXG4gICAgaWYgKGluY2x1ZGVEb2N1bWVudHMpIHtcbiAgICAgIGF3YWl0IHRoaXMubGlzdExpZW5Eb2N1bWVudHMoaWQpO1xuICAgIH1cblxuICAgIHJldHVybiBsaWVuO1xuICB9XG5cbiAgQGFjdGlvblxuICBhc3luYyBmZXRjaFByZXNldHMgKCkge1xuICAgIGNvbnN0IHByZXNldHMgPSBhd2FpdCB0aGlzLnRyYW5zcG9ydC5nZXQoJy9mdW5kZXItcHJlc2V0LWNvbnRyYWN0LXRlbXBsYXRlcy8nKTtcbiAgICByZXR1cm4gcHJlc2V0cztcbiAgfVxuXG4gIEBhY3Rpb25cbiAgYXN5bmMgdXBzZXJ0TGVnYWxGdW5kaW5nTGllbiAoeyBjYXNlSWQsIGxpZW5JZCwgZGF0YSB9KSB7XG4gICAgT2JqZWN0LmFzc2lnbihkYXRhLCB7XG4gICAgICBjYXNlOiBjYXNlSWQsXG4gICAgICBmZWVzOiBkYXRhLmZlZXMgfHwgW10sXG4gICAgICBpZDogbGllbklkIHx8IHV1aWQudjQoKSxcbiAgICB9KTtcblxuICAgIHJldHVybiAoYXdhaXQgdGhpcy51cHNlcnQoZGF0YSwgTElFTl9NT0RFTFMuTEVHQUxfRlVORElORy5rZXkpKTtcbiAgfVxuXG4gIEBhY3Rpb25cbiAgYXN5bmMgdXBzZXJ0IChkYXRhLCB0eXBlS2V5KSB7XG4gICAgY29uc3QgZW5kcG9pbnQgPSBMSUVOX01PREVMU1t0eXBlS2V5XS5lbmRwb2ludFxuICAgICAgLCB7IGlkIH0gPSBkYXRhO1xuXG4gICAgLy8gU3VwcG9ydHMgdXBzZXJ0IHZpYSBwb3N0XG4gICAgaWYgKHR5cGVLZXkgPT09IExJRU5fTU9ERUxTLkxFR0FMX0ZVTkRJTkcua2V5KSB7XG4gICAgICBhd2FpdCB0aGlzLnRyYW5zcG9ydC5wb3N0KGAvJHtlbmRwb2ludH0vYCwge2RhdGF9KTtcbiAgICB9XG5cbiAgICAvLyBVcHNlcnQgdXNpbmcgMiBlbmRwb2ludHMgLSBQT1NUXG4gICAgZWxzZSBpZiAoIWlkKSB7XG4gICAgICBkYXRhLmlkID0gdXVpZC52NCgpO1xuICAgICAgYXdhaXQgdGhpcy50cmFuc3BvcnQucG9zdChgLyR7ZW5kcG9pbnR9L2AsIHtkYXRhfSk7XG4gICAgfVxuXG4gICAgLy8gVXBzZXJ0IHVzaW5nIDIgZW5kcG9pbnRzIC0gUEFUQ0hcbiAgICBlbHNlIHtcbiAgICAgIGF3YWl0IHRoaXMudHJhbnNwb3J0LnBhdGNoKGAvJHtlbmRwb2ludH0vOmlkL2AsIHtkYXRhLCB1cmxQYXJhbXM6IHsgaWQgfX0pO1xuICAgIH1cblxuICAgIGF3YWl0IFByb21pc2UuYWxsKFtcbiAgICAgIHRoaXMubGlzdCh7IGNhc2VJZDogZGF0YS5jYXNlIH0pLFxuICAgICAgdGhpcy5jYXNlU3RvcmUucmVmcmVzaChkYXRhLmNhc2UpLFxuICAgIF0pO1xuXG4gICAgcmV0dXJuIHRoaXMuZmxhdFN0b3JlLmxpZW4uZ2V0KGRhdGEuaWQpO1xuICB9XG5cbiAgQGFjdGlvblxuICBhc3luYyBjcmVhdGVPclVwZGF0ZUdlbmVyaWNMaWVuIChkYXRhKSB7XG4gICAgYXdhaXQgdGhpcy51cHNlcnQoZGF0YSwgTElFTl9NT0RFTFMuR0VORVJJQy5rZXkpO1xuICB9XG5cbiAgQGFjdGlvblxuICBhc3luYyBkZWxldGUgKHsgY2FzZUlkLCBsaWVuSWQgfSkge1xuICAgIGNvbnN0IHsgYW1vdW50X293ZWRfdG9fY29vcCB9ID0gdGhpcy5mbGF0U3RvcmUubGllbi5nZXQobGllbklkKTtcblxuICAgIGlmIChhbW91bnRfb3dlZF90b19jb29wICE9PSBudWxsKSB7XG4gICAgICB0b2FzdC5lcnJvcihcbiAgICAgICAgJ0Nhbm5vdCBkZWxldGUgYSBsaWVuIGxpbmtlZCB0byBhIENvT3AgaW52ZXN0bWVudC4gUGxlYXNlIGNvbnRhY3QgTWlnaHR5IFN1cHBvcnQgZm9yIGZ1cnRoZXIgYXNzaXN0YW5jZS4nXG4gICAgICApO1xuICAgICAgcmV0dXJuO1xuICAgIH1cblxuICAgIGNvbnN0IHJlcXVlc3QgPSB0aGlzLnRyYW5zcG9ydC5kZWxldGUoJy9saWVucy86aWQvJywgeyB1cmxQYXJhbXM6IHsgaWQ6IGxpZW5JZCB9fSk7XG5cbiAgICBhd2FpdCB0aGlzLmNhc2VTdG9yZS5jYXNlQWN0aXZpdGllcy5sb2FkTmV3KE1PREVMX1RZUEVTLmxpZW5EZWxldGVkLmtleSwgcmVxdWVzdCk7XG4gICAgYXdhaXQgdGhpcy5saXN0KHsgY2FzZUlkIH0pO1xuICAgIGF3YWl0IHRoaXMuY2FzZVN0b3JlLnJlZnJlc2goY2FzZUlkKTtcbiAgfVxuXG4gIGFzeW5jIHJhd1VwZGF0ZSAobGllbiwgZGF0YSkge1xuICAgIGNvbnN0IGVuZHBvaW50ID0gTElFTl9NT0RFTFNfQllfTU9ERUxfTkFNRVtsaWVuLnR5cGVdLmVuZHBvaW50O1xuICAgIHJldHVybiB0aGlzLnRyYW5zcG9ydC5wYXRjaChgLyR7ZW5kcG9pbnR9LzpsaWVuSWQvYCwgeyBkYXRhLCB1cmxQYXJhbXM6IHsgbGllbklkOiBsaWVuLmlkIH0gfSk7XG4gIH1cblxuICBAYWN0aW9uXG4gIGFzeW5jIHVwZGF0ZSAobGllbiwgZGF0YSkge1xuICAgIHJldHVybiB0aGlzLmZsYXRTdG9yZS5saWVuLnN0b3JlKGF3YWl0IHRoaXMucmF3VXBkYXRlKGxpZW4sIGRhdGEpKTtcbiAgfVxuXG4gIGFzeW5jIGJ1bGtVcGRhdGUgKGxpZW5zLCBkYXRhKSB7XG4gICAgcmV0dXJuIFByb21pc2UuYWxsKGxpZW5zLm1hcCgobGllbikgPT4gdGhpcy5yYXdVcGRhdGUobGllbiwgZGF0YSkpKTtcbiAgfVxuXG4gIEBhY3Rpb25cbiAgYXN5bmMgdXBkYXRlTGllbkRvY3VtZW50IChpZCwgZGF0YSkge1xuICAgIGNvbnN0IGZvcm0gPSBGb3JtRGF0YVV0aWxzLnRvRm9ybShkYXRhKTtcbiAgICBhd2FpdCB0aGlzLnRyYW5zcG9ydC5wYXRjaCgnL2xpZW4tZG9jdW1lbnRzLzppZC8nLCB7IGRhdGE6IGZvcm0sIHVybFBhcmFtczogeyBpZCB9fSk7XG4gIH1cblxuICBAYWN0aW9uXG4gIGFzeW5jIGxpc3QgKHsgY2FzZUlkIH0pIHtcbiAgICBjb25zdCBfY2FzZSA9IHRoaXMuZmxhdFN0b3JlLmNhc2UuZ2V0KGNhc2VJZClcbiAgICAgICwgcGFyYW1zID0geyBjYXNlOiBjYXNlSWQgfTtcblxuICAgIGlmIChfY2FzZS5sb2FkaW5nTGllbnMpIHsgcmV0dXJuOyB9XG5cbiAgICBfY2FzZS5sb2FkaW5nTGllbnMgPSB0cnVlO1xuICAgIGNvbnN0IGxpZW5zID0gYXdhaXQgdGhpcy50cmFuc3BvcnQuZ2V0QWxsKCcvbGllbnMvJywgeyBwYXJhbXMgfSk7XG4gICAgbGllbnMuZm9yRWFjaChsaWVuID0+IHRoaXMuZmxhdFN0b3JlLmxpZW4uc3RvcmUobGllbikpO1xuICAgIF9jYXNlLmxpZW5zID0gbGllbnMubWFwKGxpZW4gPT4gbGllbi5pZCk7XG4gICAgX2Nhc2UubG9hZGluZ0xpZW5zID0gZmFsc2U7XG4gIH1cblxuICBAYWN0aW9uXG4gIGFzeW5jIGNyZWF0ZUxpZW5SZXR1cm4gKHsgY2FzZUlkLCBkYXRhIH0pIHtcbiAgICBhd2FpdCB0aGlzLnRyYW5zcG9ydC5wb3N0KCcvcmV0dXJucy8nLCB7IGRhdGEgfSk7XG5cbiAgICBhd2FpdCBQcm9taXNlLmFsbChbXG4gICAgICB0aGlzLmNhc2VTdG9yZS5jYXNlQWN0aXZpdGllcy5sb2FkTmV3KE1PREVMX1RZUEVTLmxpZW5SZXR1cm5BY3Rpb24ua2V5KSxcbiAgICAgIHRoaXMuY2FzZVN0b3JlLnJlZnJlc2goY2FzZUlkKSxcbiAgICAgIHRoaXMubGlzdCh7IGNhc2VJZCB9KSxcbiAgICBdKTtcbiAgfVxuXG4gIEBhY3Rpb25cbiAgYXN5bmMgZGVsZXRlTGllblJldHVybiAocmV0dXJuSWQsIGxpZW5JZCwgY2FzZUlkKSB7XG4gICAgYXdhaXQgdGhpcy50cmFuc3BvcnQuZGVsZXRlKCcvcmV0dXJucy86cmV0dXJuSWQvJywge3VybFBhcmFtczogeyByZXR1cm5JZCB9fSk7XG5cbiAgICBhd2FpdCBQcm9taXNlLmFsbChbXG4gICAgICB0aGlzLmNhc2VTdG9yZS5jYXNlQWN0aXZpdGllcy5sb2FkTmV3KE1PREVMX1RZUEVTLmxpZW5SZXR1cm5BY3Rpb24ua2V5KSxcbiAgICAgIHRoaXMuY2FzZVN0b3JlLnJlZnJlc2goY2FzZUlkKSxcbiAgICAgIHRoaXMubGlzdCh7IGNhc2VJZCB9KSxcbiAgICBdKTtcbiAgfVxuXG4gIEBhY3Rpb25cbiAgYXN5bmMgY3JlYXRlTGllbkRvY3VtZW50ICh7IGxpZW5JZCwgZGF0YSB9KSB7XG4gICAgY29uc3QgZm9ybSA9IG5ldyB3aW5kb3cuRm9ybURhdGEoKTtcblxuICAgIGZvcm0uYXBwZW5kKCdsaWVuJywgbGllbklkKTtcbiAgICBmb3JtLmFwcGVuZCgnZmlsZScsIGRhdGEuZmlsZSk7XG4gICAgZm9ybS5hcHBlbmQoJ25hbWUnLCBkYXRhLm5hbWUpO1xuXG4gICAgY29uc3QgbGllbkRvY3VtZW50ID0gYXdhaXQgdGhpcy50cmFuc3BvcnQucG9zdCgnL2xpZW4tZG9jdW1lbnRzLycsIHsgZGF0YTogZm9ybSB9KVxuICAgICAgLCBsaWVuID0gdGhpcy5mbGF0U3RvcmUubGllbi5nZXQobGllbklkKTtcblxuICAgIGxpZW4uZG9jdW1lbnRzLnB1c2gobGllbkRvY3VtZW50KTtcbiAgfVxuXG4gIEBhY3Rpb25cbiAgYXN5bmMgZGVsZXRlTGllbkRvY3VtZW50IChsaWVuSWQsIGNhc2VJZCwgaWQpIHtcbiAgICBjb25zdCByZXF1ZXN0ID0gdGhpcy50cmFuc3BvcnQuZGVsZXRlKCcvbGllbi1kb2N1bWVudHMvOmlkLycsIHsgdXJsUGFyYW1zOiB7IGlkOiBpZCB9IH0pO1xuXG4gICAgYXdhaXQgdGhpcy5jYXNlU3RvcmUuY2FzZUFjdGl2aXRpZXMubG9hZE5ldyhNT0RFTF9UWVBFUy5kZWxldGVkTGllbkRvY3VtZW50LmtleSwgcmVxdWVzdCk7XG4gICAgdGhpcy5jYXNlU3RvcmUuZmV0Y2hUYWJDb3VudHMoY2FzZUlkKTtcbiAgfVxuXG4gIEBhY3Rpb25cbiAgYXN5bmMgbGlzdExpZW5Eb2N1bWVudHMgKGxpZW5JZCkge1xuICAgIGNvbnN0IHBhcmFtcyA9IHsgbGllbjogbGllbklkLCBwYWdlX3NpemU6ICdvZmYnIH1cbiAgICAgICwgZG9jdW1lbnRzID0gYXdhaXQgdGhpcy50cmFuc3BvcnQuZ2V0KCcvbGllbi1kb2N1bWVudHMvJywgeyBwYXJhbXMgfSlcbiAgICAgICwgbGllbiA9IHRoaXMuZmxhdFN0b3JlLmxpZW4uZ2V0KGxpZW5JZCk7XG5cbiAgICBsaWVuLmV4dGVuZCh7IGRvY3VtZW50cyB9KTtcbiAgfVxuXG4gIEBhY3Rpb25cbiAgYXN5bmMgbGlzdENhc2VMaWVuRG9jdW1lbnRzIChjYXNlSWQpIHtcbiAgICBjb25zdCBwYXJhbXMgPSB7IGNhc2U6IGNhc2VJZCwgcGFnZV9zaXplOiAnb2ZmJyB9O1xuXG4gICAgcmV0dXJuIChhd2FpdCB0aGlzLnRyYW5zcG9ydC5nZXQoJy9saWVuLWRvY3VtZW50cy8nLCB7IHBhcmFtcyB9KSk7XG4gIH1cblxuICBkb3dubG9hZENvbnRyYWN0IChsaWVuKSB7XG4gICAgd2luZG93LmxvY2F0aW9uID0gdGhpcy50cmFuc3BvcnQuYWRkQXV0aGVudGljYXRpb25Ub1VybChsaWVuLmNvbnRyYWN0X2Rvd25sb2FkX3VybCk7XG4gIH1cblxuICB1cGRhdGVGdW5kaW5nIChmdW5kaW5nKSB7XG4gICAgY29uc3QgbGllbiA9IHRoaXMuZmxhdFN0b3JlLmxpZW4uZ2V0KGZ1bmRpbmcubGllbilcbiAgICAgICwgZnVuZGluZ0luZGV4ID0gZmluZEluZGV4KGxpZW4uY2FwaXRhbF9mdW5kaW5ncywgeyBpZDogZnVuZGluZy5pZCB9KVxuICAgICAgO1xuXG4gICAgaWYgKGZ1bmRpbmdJbmRleCA8IDApIHtcbiAgICAgIGxpZW4uY2FwaXRhbF9mdW5kaW5ncy5wdXNoKGZ1bmRpbmcpO1xuICAgIH1cbiAgICBlbHNlIHtcbiAgICAgIGV4dGVuZE9ic2VydmFibGUobGllbi5jYXBpdGFsX2Z1bmRpbmdzW2Z1bmRpbmdJbmRleF0sIGZ1bmRpbmcpO1xuICAgIH1cbiAgfVxufVxuXG5leHBvcnQgZGVmYXVsdCBMaWVuU3RvcmU7XG4iXX0=